import { observable, makeAutoObservable } from 'mobx';
import _ from 'lodash';

class MultipleChoiceFormState {
  question;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({question}) {
    this.question = question;

    if (_.isEmpty(this.question.options)) {
      _.set(this.question, 'args.options', observable([]));
      this.addOption();
    } else {
      this.question.args.options = observable(this.question.args.options);
    }
  }

  get options() {
    return _.get(this.question.args, 'options');
  }

  addOption() {
    this.question.args.options.push({value: ''});
  }

  removeOption(option) {
    this.question.args.options.remove(option);
  }
}

export default MultipleChoiceFormState;
